import styled from 'styled-components'

export const DetailsMenuContainer = styled.div`
  position: sticky;
  top: 1.5rem;
  align-self: flex-start;

  @media only screen and (max-width: 900px) {
    position: relative;
    top: 0;
  }
`
